import { render } from "./ProcessoIAAnalise.vue?vue&type=template&id=29092556&scoped=true"
import script from "./ProcessoIAAnalise.vue?vue&type=script&lang=js"
export * from "./ProcessoIAAnalise.vue?vue&type=script&lang=js"

import "./ProcessoIAAnalise.vue?vue&type=style&index=0&id=29092556&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29092556"]])

export default __exports__